var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import appEnv from "./appEnv";
import notFound from "./common/notFound";
import mpAlipayCreateWebViewContext from "./clients/mp/alipay/createWebViewContext";
import _navigateTo from "./common/apis/generated/navigateTo";
import _rpc from "./common/apis/generated/rpc";
import mpAlipayTradePay from "./clients/mp/alipay/tradePay";
import _addFatigueAction from "./common/apis/generated/addFatigueAction";
import _addPhoneContact from "./common/apis/generated/addPhoneContact";
import _alert from "./common/apis/generated/alert";
import _apDisableJSAPI from "./common/apis/generated/apDisableJSAPI";
import _appxrpc from "./common/apis/generated/appxrpc";
import _APRegionRPC from "./common/apis/generated/APRegionRPC";
import _batchQueryCdpSpaceInfo from "./common/apis/generated/batchQueryCdpSpaceInfo";
import _chooseImage from "./common/apis/generated/chooseImage";
import _choosePhoneContact from "./common/apis/generated/choosePhoneContact";
import _clearStorage from "./common/apis/generated/clearStorage";
import _clearStorageSync from "./common/apis/generated/clearStorageSync";
import _closeBluetoothAdapter from "./common/apis/generated/closeBluetoothAdapter";
import _closeSocket from "./common/apis/generated/closeSocket";
import _confirm from "./common/apis/generated/confirm";
import _connectBLEDevice from "./common/apis/generated/connectBLEDevice";
import _connectSocket from "./common/apis/generated/connectSocket";
import _createAnimation from "./common/apis/generated/createAnimation";
import mpAlipayPlusCreateWebViewContext from "./clients/mp/alipay_plus/createWebViewContext";
import _crossPay from "./common/apis/generated/crossPay";
import _datePicker from "./common/apis/generated/datePicker";
import _disconnectBLEDevice from "./common/apis/generated/disconnectBLEDevice";
import _downloadFile from "./common/apis/generated/downloadFile";
import _exitApp from "./common/apis/generated/exitApp";
import _getAppIdSync from "./common/apis/generated/getAppIdSync";
import _getAppToken from "./common/apis/generated/getAppToken";
import _getAuthCode from "./common/apis/generated/getAuthCode";
import _getBatteryInfo from "./common/apis/generated/getBatteryInfo";
import _getBLEDeviceCharacteristics from "./common/apis/generated/getBLEDeviceCharacteristics";
import _getBLEDeviceServices from "./common/apis/generated/getBLEDeviceServices";
import _getBluetoothAdapterState from "./common/apis/generated/getBluetoothAdapterState";
import _getBluetoothDevices from "./common/apis/generated/getBluetoothDevices";
import _getClipboard from "./common/apis/generated/getClipboard";
import _getComponentAuth from "./common/apis/generated/getComponentAuth";
import _getConnectedBluetoothDevices from "./common/apis/generated/getConnectedBluetoothDevices";
import _getFileInfo from "./common/apis/generated/getFileInfo";
import _getImageInfo from "./common/apis/generated/getImageInfo";
import _getLocation from "./common/apis/generated/getLocation";
import _getNetworkType from "./common/apis/generated/getNetworkType";
import _getOpenUserInfo from "./common/apis/generated/getOpenUserInfo";
import _getPaymentCode from "./common/apis/generated/getPaymentCode";
import _getPhoneNumber from "./common/apis/generated/getPhoneNumber";
import _getSavedFileInfo from "./common/apis/generated/getSavedFileInfo";
import _getSavedFileList from "./common/apis/generated/getSavedFileList";
import _getScreenBrightness from "./common/apis/generated/getScreenBrightness";
import _getServerTime from "./common/apis/generated/getServerTime";
import _getSetting from "./common/apis/generated/getSetting";
import _getSiteInfo from "./common/apis/generated/getSiteInfo";
import _getStorage from "./common/apis/generated/getStorage";
import _getStorageSync from "./common/apis/generated/getStorageSync";
import _getSystemInfo from "./common/apis/generated/getSystemInfo";
import _getSystemInfoSync from "./common/apis/generated/getSystemInfoSync";
import _hideBackHome from "./common/apis/generated/hideBackHome";
import _hideKeyboard from "./common/apis/generated/hideKeyboard";
import _hideLoading from "./common/apis/generated/hideLoading";
import _hideNavigationBarLoading from "./common/apis/generated/hideNavigationBarLoading";
import _hideTabBar from "./common/apis/generated/hideTabBar";
import _hideToast from "./common/apis/generated/hideToast";
import _inquireQuote from "./common/apis/generated/inquireQuote";
import _isInstalledApp from "./common/apis/generated/isInstalledApp";
import _makePhoneCall from "./common/apis/generated/makePhoneCall";
import _multiLevelSelect from "./common/apis/generated/multiLevelSelect";
import _navigateBack from "./common/apis/generated/navigateBack";
import _navigateBackMiniProgram from "./common/apis/generated/navigateBackMiniProgram";
import _navigateToBizScene from "./common/apis/generated/navigateToBizScene";
import _navigateToMiniProgram from "./common/apis/generated/navigateToMiniProgram";
import _notifyBLECharacteristicValueChange from "./common/apis/generated/notifyBLECharacteristicValueChange";
import _offAccelerometerChange from "./common/apis/generated/offAccelerometerChange";
import _offBLECharacteristicValueChange from "./common/apis/generated/offBLECharacteristicValueChange";
import _offBLEConnectionStateChanged from "./common/apis/generated/offBLEConnectionStateChanged";
import _offBluetoothAdapterStateChange from "./common/apis/generated/offBluetoothAdapterStateChange";
import _offBluetoothDeviceFound from "./common/apis/generated/offBluetoothDeviceFound";
import _offCompassChange from "./common/apis/generated/offCompassChange";
import _offMemoryWarning from "./common/apis/generated/offMemoryWarning";
import _offSocketClose from "./common/apis/generated/offSocketClose";
import _offSocketError from "./common/apis/generated/offSocketError";
import _offSocketMessage from "./common/apis/generated/offSocketMessage";
import _offSocketOpen from "./common/apis/generated/offSocketOpen";
import _offUserCaptureScreen from "./common/apis/generated/offUserCaptureScreen";
import _onAccelerometerChange from "./common/apis/generated/onAccelerometerChange";
import _onBLECharacteristicValueChange from "./common/apis/generated/onBLECharacteristicValueChange";
import _onBLEConnectionStateChanged from "./common/apis/generated/onBLEConnectionStateChanged";
import _onBluetoothAdapterStateChange from "./common/apis/generated/onBluetoothAdapterStateChange";
import _onBluetoothDeviceFound from "./common/apis/generated/onBluetoothDeviceFound";
import _onCompassChange from "./common/apis/generated/onCompassChange";
import _onMemoryWarning from "./common/apis/generated/onMemoryWarning";
import _onSocketClose from "./common/apis/generated/onSocketClose";
import _onSocketError from "./common/apis/generated/onSocketError";
import _onSocketMessage from "./common/apis/generated/onSocketMessage";
import _onSocketOpen from "./common/apis/generated/onSocketOpen";
import _onUserCaptureScreen from "./common/apis/generated/onUserCaptureScreen";
import _openBluetoothAdapter from "./common/apis/generated/openBluetoothAdapter";
import _openDocument from "./common/apis/generated/openDocument";
import _openSchemeWithBacking from "./common/apis/generated/openSchemeWithBacking";
import _openSetting from "./common/apis/generated/openSetting";
import _pageScrollTo from "./common/apis/generated/pageScrollTo";
import _paySignCenter from "./common/apis/generated/paySignCenter";
import _previewImage from "./common/apis/generated/previewImage";
import _prompt from "./common/apis/generated/prompt";
import _readBLECharacteristicValue from "./common/apis/generated/readBLECharacteristicValue";
import _redirectTo from "./common/apis/generated/redirectTo";
import _regionFetchAllApps from "./common/apis/generated/regionFetchAllApps";
import _regionSearchAppsByKeywords from "./common/apis/generated/regionSearchAppsByKeywords";
import _reLaunch from "./common/apis/generated/reLaunch";
import _removeSavedFile from "./common/apis/generated/removeSavedFile";
import _removeStorage from "./common/apis/generated/removeStorage";
import _removeStorageSync from "./common/apis/generated/removeStorageSync";
import _request from "./common/apis/generated/request";
import _saveFile from "./common/apis/generated/saveFile";
import _saveImage from "./common/apis/generated/saveImage";
import _scan from "./common/apis/generated/scan";
import _sendSocketMessage from "./common/apis/generated/sendSocketMessage";
import _setBackgroundColor from "./common/apis/generated/setBackgroundColor";
import _setCanPullDown from "./common/apis/generated/setCanPullDown";
import _setClipboard from "./common/apis/generated/setClipboard";
import _setKeepScreenOn from "./common/apis/generated/setKeepScreenOn";
import _setNavigationBar from "./common/apis/generated/setNavigationBar";
import _setOptionMenu from "./common/apis/generated/setOptionMenu";
import _setScreenBrightness from "./common/apis/generated/setScreenBrightness";
import _setStorage from "./common/apis/generated/setStorage";
import _setStorageSync from "./common/apis/generated/setStorageSync";
import _setTabBarStyle from "./common/apis/generated/setTabBarStyle";
import _showActionSheet from "./common/apis/generated/showActionSheet";
import _showAuthGuide from "./common/apis/generated/showAuthGuide";
import _showLoading from "./common/apis/generated/showLoading";
import _showNavigationBarLoading from "./common/apis/generated/showNavigationBarLoading";
import _showToast from "./common/apis/generated/showToast";
import _signContract from "./common/apis/generated/signContract";
import _startApp from "./common/apis/generated/startApp";
import _startBizService from "./common/apis/generated/startBizService";
import _startBluetoothDevicesDiscovery from "./common/apis/generated/startBluetoothDevicesDiscovery";
import _startPullDownRefresh from "./common/apis/generated/startPullDownRefresh";
import _stopBluetoothDevicesDiscovery from "./common/apis/generated/stopBluetoothDevicesDiscovery";
import _stopPullDownRefresh from "./common/apis/generated/stopPullDownRefresh";
import _switchTab from "./common/apis/generated/switchTab";
import _thirdPartyAuthForAc from "./common/apis/generated/thirdPartyAuthForAc";
import _tradePay from "./common/apis/generated/tradePay";
import _uploadApdidToken from "./common/apis/generated/uploadApdidToken";
import _uploadFile from "./common/apis/generated/uploadFile";
import _vibrate from "./common/apis/generated/vibrate";
import _watchShake from "./common/apis/generated/watchShake";
import _writeBLECharacteristicValue from "./common/apis/generated/writeBLECharacteristicValue";
import _createSelectorQuery from "./common/apis/generated/createSelectorQuery";
import mpAlipayPlusCanIUse from "./clients/mp/alipay_plus/canIUse";
import _getStorageInfo from "./common/apis/generated/getStorageInfo";
import _getStorageInfoSync from "./common/apis/generated/getStorageInfoSync";
import _showSharePanel from "./common/apis/generated/showSharePanel";
import _postMessage from "./common/apis/generated/postMessage";
import _onMessage from "./common/apis/generated/onMessage";
import mpLazadaCreateWebViewContext from "./clients/mp/lazada/createWebViewContext";
import mpLazadaGetAuthCode from "./clients/mp/lazada/getAuthCode";
import mpTaobaoCreateWebViewContext from "./clients/mp/taobao/createWebViewContext";
import mpTaobaoCrossPay from "./clients/mp/taobao/crossPay";
import mpTaobaoGetAuthCode from "./clients/mp/taobao/getAuthCode";
import mpTaobaoGetOpenUserInfo from "./clients/mp/taobao/getOpenUserInfo";
import mpWebAlipayGetAppIdSync from "./clients/mp_web/alipay/getAppIdSync";
import mpWebAlipayTradePay from "./clients/mp_web/alipay/tradePay";
import mpWebAlipayPlusGetAppIdSync from "./clients/mp_web/alipay_plus/getAppIdSync";
import webAlipayAlert from "./clients/web/alipay/alert";
import webAlipayChooseImage from "./clients/web/alipay/chooseImage";
import webAlipayChoosePhoneContact from "./clients/web/alipay/choosePhoneContact";
import webAlipayClearStorage from "./clients/web/alipay/clearStorage";
import webAlipayConfirm from "./clients/web/alipay/confirm";
import webAlipayDatePicker from "./clients/web/alipay/datePicker";
import webAlipayDownloadFile from "./clients/web/alipay/downloadFile";
import webAlipayExitApp from "./clients/web/alipay/exitApp";
import webAlipayGetAuthCode from "./clients/web/alipay/getAuthCode";
import webAlipayGetLocation from "./clients/web/alipay/getLocation";
import webAlipayGetNetworkType from "./clients/web/alipay/getNetworkType";
import webAlipayGetPhoneNumber from "./clients/web/alipay/getPhoneNumber";
import webAlipayGetStorage from "./clients/web/alipay/getStorage";
import webAlipayHideLoading from "./clients/web/alipay/hideLoading";
import webAlipayHideNavigationBarLoading from "./clients/web/alipay/hideNavigationBarLoading";
import webAlipayMultiLevelSelect from "./clients/web/alipay/multiLevelSelect";
import webAlipayNavigateBack from "./clients/web/alipay/navigateBack";
import webAlipayNavigateTo from "./clients/web/alipay/navigateTo";
import webAlipayPreviewImage from "./clients/web/alipay/previewImage";
import webAlipayRedirectTo from "./clients/web/alipay/redirectTo";
import webAlipayRemoveStorage from "./clients/web/alipay/removeStorage";
import webAlipayRequest from "./clients/web/alipay/request";
import webAlipaySaveImage from "./clients/web/alipay/saveImage";
import webAlipaySetKeepScreenOn from "./clients/web/alipay/setKeepScreenOn";
import webAlipaySetNavigationBar from "./clients/web/alipay/setNavigationBar";
import webAlipaySetOptionMenu from "./clients/web/alipay/setOptionMenu";
import webAlipaySetStorage from "./clients/web/alipay/setStorage";
import webAlipayShowActionSheet from "./clients/web/alipay/showActionSheet";
import webAlipayShowAuthGuide from "./clients/web/alipay/showAuthGuide";
import webAlipayShowLoading from "./clients/web/alipay/showLoading";
import webAlipayShowNavigationBarLoading from "./clients/web/alipay/showNavigationBarLoading";
import webAlipayShowToast from "./clients/web/alipay/showToast";
import webAlipayTradePay from "./clients/web/alipay/tradePay";
import webAlipayUploadFile from "./clients/web/alipay/uploadFile";
import webAlipayHideOptionButton from "./clients/web/alipay/hideOptionButton";
import webAlipayPlusAlert from "./clients/web/alipay_plus/alert";
import webAlipayPlusChooseImage from "./clients/web/alipay_plus/chooseImage";
import webAlipayPlusChoosePhoneContact from "./clients/web/alipay_plus/choosePhoneContact";
import webAlipayPlusClearStorage from "./clients/web/alipay_plus/clearStorage";
import webAlipayPlusConfirm from "./clients/web/alipay_plus/confirm";
import webAlipayPlusDatePicker from "./clients/web/alipay_plus/datePicker";
import webAlipayPlusDownloadFile from "./clients/web/alipay_plus/downloadFile";
import webAlipayPlusExitApp from "./clients/web/alipay_plus/exitApp";
import webAlipayPlusGetAuthCode from "./clients/web/alipay_plus/getAuthCode";
import webAlipayPlusGetLocation from "./clients/web/alipay_plus/getLocation";
import webAlipayPlusGetNetworkType from "./clients/web/alipay_plus/getNetworkType";
import webAlipayPlusGetOpenUserInfo from "./clients/web/alipay_plus/getOpenUserInfo";
import webAlipayPlusGetPhoneNumber from "./clients/web/alipay_plus/getPhoneNumber";
import webAlipayPlusGetStorage from "./clients/web/alipay_plus/getStorage";
import webAlipayPlusHideLoading from "./clients/web/alipay_plus/hideLoading";
import webAlipayPlusHideNavigationBarLoading from "./clients/web/alipay_plus/hideNavigationBarLoading";
import webAlipayPlusMultiLevelSelect from "./clients/web/alipay_plus/multiLevelSelect";
import webAlipayPlusNavigateBack from "./clients/web/alipay_plus/navigateBack";
import webAlipayPlusNavigateTo from "./clients/web/alipay_plus/navigateTo";
import webAlipayPlusPaySignCenter from "./clients/web/alipay_plus/paySignCenter";
import webAlipayPlusPreviewImage from "./clients/web/alipay_plus/previewImage";
import webAlipayPlusRedirectTo from "./clients/web/alipay_plus/redirectTo";
import webAlipayPlusRemoveStorage from "./clients/web/alipay_plus/removeStorage";
import webAlipayPlusRequest from "./clients/web/alipay_plus/request";
import webAlipayPlusSaveImage from "./clients/web/alipay_plus/saveImage";
import webAlipayPlusSetKeepScreenOn from "./clients/web/alipay_plus/setKeepScreenOn";
import webAlipayPlusSetNavigationBar from "./clients/web/alipay_plus/setNavigationBar";
import webAlipayPlusSetOptionMenu from "./clients/web/alipay_plus/setOptionMenu";
import webAlipayPlusSetStorage from "./clients/web/alipay_plus/setStorage";
import webAlipayPlusShowActionSheet from "./clients/web/alipay_plus/showActionSheet";
import webAlipayPlusShowAuthGuide from "./clients/web/alipay_plus/showAuthGuide";
import webAlipayPlusShowLoading from "./clients/web/alipay_plus/showLoading";
import webAlipayPlusShowNavigationBarLoading from "./clients/web/alipay_plus/showNavigationBarLoading";
import webAlipayPlusShowToast from "./clients/web/alipay_plus/showToast";
import webAlipayPlusUploadFile from "./clients/web/alipay_plus/uploadFile";
import webH5Alert from "./clients/web/h5/alert";
import webH5ClearStorage from "./clients/web/h5/clearStorage";
import webH5ClearStorageSync from "./clients/web/h5/clearStorageSync";
import webH5Confirm from "./clients/web/h5/confirm";
import webH5ExitApp from "./clients/web/h5/exitApp";
import webH5GetAppIdSync from "./clients/web/h5/getAppIdSync";
import webH5GetClipboard from "./clients/web/h5/getClipboard";
import webH5GetLocation from "./clients/web/h5/getLocation";
import webH5GetNetworkType from "./clients/web/h5/getNetworkType";
import webH5GetServerTime from "./clients/web/h5/getServerTime";
import webH5GetSiteInfo from "./clients/web/h5/getSiteInfo";
import webH5GetStorage from "./clients/web/h5/getStorage";
import webH5GetStorageSync from "./clients/web/h5/getStorageSync";
import webH5GetSystemInfo from "./clients/web/h5/getSystemInfo";
import webH5GetSystemInfoSync from "./clients/web/h5/getSystemInfoSync";
import webH5HideLoading from "./clients/web/h5/hideLoading";
import webH5HideToast from "./clients/web/h5/hideToast";
import webH5MakePhoneCall from "./clients/web/h5/makePhoneCall";
import webH5NavigateBack from "./clients/web/h5/navigateBack";
import webH5NavigateTo from "./clients/web/h5/navigateTo";
import webH5NavigateToBizScene from "./clients/web/h5/navigateToBizScene";
import webH5NavigateToMiniProgram from "./clients/web/h5/navigateToMiniProgram";
import webH5PageScrollTo from "./clients/web/h5/pageScrollTo";
import webH5RedirectTo from "./clients/web/h5/redirectTo";
import webH5RemoveStorage from "./clients/web/h5/removeStorage";
import webH5RemoveStorageSync from "./clients/web/h5/removeStorageSync";
import webH5Request from "./clients/web/h5/request";
import webH5Rpc from "./clients/web/h5/rpc";
import webH5SetClipboard from "./clients/web/h5/setClipboard";
import webH5SetNavigationBar from "./clients/web/h5/setNavigationBar";
import webH5SetStorage from "./clients/web/h5/setStorage";
import webH5SetStorageSync from "./clients/web/h5/setStorageSync";
import webH5ShowLoading from "./clients/web/h5/showLoading";
import webH5ShowToast from "./clients/web/h5/showToast";
import webH5GetLaunchOptionsSync from "./clients/web/h5/getLaunchOptionsSync";
import webH5CreateSelectorQuery from "./clients/web/h5/createSelectorQuery";
export var addFatigueAction = function addFatigueAction() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _addFatigueAction.apply(void 0, rest);
  if (appEnv.isMpLazada) return _addFatigueAction.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _addFatigueAction.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _addFatigueAction.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['addFatigueAction'], rest, false));
};
export var addPhoneContact = function addPhoneContact() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _addPhoneContact.apply(void 0, rest);
  if (appEnv.isMpLazada) return _addPhoneContact.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _addPhoneContact.apply(void 0, rest);
  if (appEnv.isWebAlipay) return _addPhoneContact.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _addPhoneContact.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['addPhoneContact'], rest, false));
};
export var alert = function alert() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _alert.apply(void 0, rest);
  if (appEnv.isMpLazada) return _alert.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _alert.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _alert.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _alert.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipayAlert.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusAlert.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5Alert.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['alert'], rest, false));
};
export var apDisableJSAPI = function apDisableJSAPI() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _apDisableJSAPI.apply(void 0, rest);
  if (appEnv.isMpLazada) return _apDisableJSAPI.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _apDisableJSAPI.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _apDisableJSAPI.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['apDisableJSAPI'], rest, false));
};
export var appxrpc = function appxrpc() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _appxrpc.apply(void 0, rest);
  if (appEnv.isMpLazada) return _appxrpc.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _appxrpc.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _appxrpc.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['appxrpc'], rest, false));
};
export var APRegionRPC = function APRegionRPC() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _APRegionRPC.apply(void 0, rest);
  if (appEnv.isMpLazada) return _APRegionRPC.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _APRegionRPC.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _APRegionRPC.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['APRegionRPC'], rest, false));
};
export var batchQueryCdpSpaceInfo = function batchQueryCdpSpaceInfo() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _batchQueryCdpSpaceInfo.apply(void 0, rest);
  if (appEnv.isMpLazada) return _batchQueryCdpSpaceInfo.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _batchQueryCdpSpaceInfo.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _batchQueryCdpSpaceInfo.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['batchQueryCdpSpaceInfo'], rest, false));
};
export var chooseImage = function chooseImage() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _chooseImage.apply(void 0, rest);
  if (appEnv.isMpLazada) return _chooseImage.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _chooseImage.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _chooseImage.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipayChooseImage.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusChooseImage.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['chooseImage'], rest, false));
};
export var choosePhoneContact = function choosePhoneContact() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _choosePhoneContact.apply(void 0, rest);
  if (appEnv.isMpLazada) return _choosePhoneContact.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _choosePhoneContact.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipayChoosePhoneContact.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusChoosePhoneContact.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['choosePhoneContact'], rest, false));
};
export var clearStorage = function clearStorage() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _clearStorage.apply(void 0, rest);
  if (appEnv.isMpLazada) return _clearStorage.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _clearStorage.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _clearStorage.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _clearStorage.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipayClearStorage.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusClearStorage.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5ClearStorage.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['clearStorage'], rest, false));
};
export var clearStorageSync = function clearStorageSync() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _clearStorageSync.apply(void 0, rest);
  if (appEnv.isMpLazada) return _clearStorageSync.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _clearStorageSync.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5ClearStorageSync.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['clearStorageSync'], rest, false));
};
export var closeBluetoothAdapter = function closeBluetoothAdapter() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _closeBluetoothAdapter.apply(void 0, rest);
  if (appEnv.isMpLazada) return _closeBluetoothAdapter.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _closeBluetoothAdapter.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['closeBluetoothAdapter'], rest, false));
};
export var closeSocket = function closeSocket() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _closeSocket.apply(void 0, rest);
  if (appEnv.isMpLazada) return _closeSocket.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _closeSocket.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['closeSocket'], rest, false));
};
export var confirm = function confirm() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _confirm.apply(void 0, rest);
  if (appEnv.isMpLazada) return _confirm.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _confirm.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _confirm.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _confirm.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipayConfirm.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusConfirm.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5Confirm.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['confirm'], rest, false));
};
export var connectBLEDevice = function connectBLEDevice() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _connectBLEDevice.apply(void 0, rest);
  if (appEnv.isMpLazada) return _connectBLEDevice.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _connectBLEDevice.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['connectBLEDevice'], rest, false));
};
export var connectSocket = function connectSocket() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _connectSocket.apply(void 0, rest);
  if (appEnv.isMpLazada) return _connectSocket.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _connectSocket.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['connectSocket'], rest, false));
};
export var createAnimation = function createAnimation() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _createAnimation.apply(void 0, rest);
  if (appEnv.isMpLazada) return _createAnimation.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _createAnimation.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['createAnimation'], rest, false));
};
export var createWebViewContext = function createWebViewContext() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipay) return mpAlipayCreateWebViewContext.apply(void 0, rest);
  if (appEnv.isMpAlipayPlus) return mpAlipayPlusCreateWebViewContext.apply(void 0, rest);
  if (appEnv.isMpLazada) return mpLazadaCreateWebViewContext.apply(void 0, rest);
  if (appEnv.isMpTaobao) return mpTaobaoCreateWebViewContext.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['createWebViewContext'], rest, false));
};
export var crossPay = function crossPay() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _crossPay.apply(void 0, rest);
  if (appEnv.isMpLazada) return _crossPay.apply(void 0, rest);
  if (appEnv.isMpTaobao) return mpTaobaoCrossPay.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _crossPay.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _crossPay.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _crossPay.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['crossPay'], rest, false));
};
export var datePicker = function datePicker() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _datePicker.apply(void 0, rest);
  if (appEnv.isMpLazada) return _datePicker.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _datePicker.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipayDatePicker.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusDatePicker.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['datePicker'], rest, false));
};
export var disconnectBLEDevice = function disconnectBLEDevice() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _disconnectBLEDevice.apply(void 0, rest);
  if (appEnv.isMpLazada) return _disconnectBLEDevice.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _disconnectBLEDevice.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['disconnectBLEDevice'], rest, false));
};
export var downloadFile = function downloadFile() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _downloadFile.apply(void 0, rest);
  if (appEnv.isMpLazada) return _downloadFile.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _downloadFile.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipayDownloadFile.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusDownloadFile.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['downloadFile'], rest, false));
};
export var exitApp = function exitApp() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _exitApp.apply(void 0, rest);
  if (appEnv.isMpLazada) return _exitApp.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _exitApp.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipayExitApp.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusExitApp.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5ExitApp.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['exitApp'], rest, false));
};
export var getAppIdSync = function getAppIdSync() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getAppIdSync.apply(void 0, rest);
  if (appEnv.isMpLazada) return _getAppIdSync.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return mpWebAlipayGetAppIdSync.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return mpWebAlipayPlusGetAppIdSync.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5GetAppIdSync.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getAppIdSync'], rest, false));
};
export var getAppToken = function getAppToken() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getAppToken.apply(void 0, rest);
  if (appEnv.isMpLazada) return _getAppToken.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _getAppToken.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _getAppToken.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getAppToken'], rest, false));
};
export var getAuthCode = function getAuthCode() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getAuthCode.apply(void 0, rest);
  if (appEnv.isMpLazada) return mpLazadaGetAuthCode.apply(void 0, rest);
  if (appEnv.isMpTaobao) return mpTaobaoGetAuthCode.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _getAuthCode.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _getAuthCode.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipayGetAuthCode.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusGetAuthCode.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getAuthCode'], rest, false));
};
export var getBatteryInfo = function getBatteryInfo() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getBatteryInfo.apply(void 0, rest);
  if (appEnv.isMpLazada) return _getBatteryInfo.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _getBatteryInfo.apply(void 0, rest);
  if (appEnv.isWebAlipay) return _getBatteryInfo.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _getBatteryInfo.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getBatteryInfo'], rest, false));
};
export var getBLEDeviceCharacteristics = function getBLEDeviceCharacteristics() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getBLEDeviceCharacteristics.apply(void 0, rest);
  if (appEnv.isMpLazada) return _getBLEDeviceCharacteristics.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _getBLEDeviceCharacteristics.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getBLEDeviceCharacteristics'], rest, false));
};
export var getBLEDeviceServices = function getBLEDeviceServices() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getBLEDeviceServices.apply(void 0, rest);
  if (appEnv.isMpLazada) return _getBLEDeviceServices.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _getBLEDeviceServices.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getBLEDeviceServices'], rest, false));
};
export var getBluetoothAdapterState = function getBluetoothAdapterState() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getBluetoothAdapterState.apply(void 0, rest);
  if (appEnv.isMpLazada) return _getBluetoothAdapterState.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _getBluetoothAdapterState.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getBluetoothAdapterState'], rest, false));
};
export var getBluetoothDevices = function getBluetoothDevices() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getBluetoothDevices.apply(void 0, rest);
  if (appEnv.isMpLazada) return _getBluetoothDevices.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _getBluetoothDevices.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getBluetoothDevices'], rest, false));
};
export var getClipboard = function getClipboard() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getClipboard.apply(void 0, rest);
  if (appEnv.isMpLazada) return _getClipboard.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _getClipboard.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _getClipboard.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _getClipboard.apply(void 0, rest);
  if (appEnv.isWebAlipay) return _getClipboard.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _getClipboard.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5GetClipboard.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getClipboard'], rest, false));
};
export var getComponentAuth = function getComponentAuth() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getComponentAuth.apply(void 0, rest);
  if (appEnv.isMpLazada) return _getComponentAuth.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _getComponentAuth.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _getComponentAuth.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getComponentAuth'], rest, false));
};
export var getConnectedBluetoothDevices = function getConnectedBluetoothDevices() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getConnectedBluetoothDevices.apply(void 0, rest);
  if (appEnv.isMpLazada) return _getConnectedBluetoothDevices.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _getConnectedBluetoothDevices.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getConnectedBluetoothDevices'], rest, false));
};
export var getFileInfo = function getFileInfo() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getFileInfo.apply(void 0, rest);
  if (appEnv.isMpLazada) return _getFileInfo.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _getFileInfo.apply(void 0, rest);
  if (appEnv.isWebAlipay) return _getFileInfo.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _getFileInfo.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getFileInfo'], rest, false));
};
export var getImageInfo = function getImageInfo() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getImageInfo.apply(void 0, rest);
  if (appEnv.isMpLazada) return _getImageInfo.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _getImageInfo.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _getImageInfo.apply(void 0, rest);
  if (appEnv.isWebAlipay) return _getImageInfo.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _getImageInfo.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getImageInfo'], rest, false));
};
export var getLocation = function getLocation() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getLocation.apply(void 0, rest);
  if (appEnv.isMpLazada) return _getLocation.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _getLocation.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _getLocation.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _getLocation.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipayGetLocation.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusGetLocation.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5GetLocation.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getLocation'], rest, false));
};
export var getNetworkType = function getNetworkType() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getNetworkType.apply(void 0, rest);
  if (appEnv.isMpLazada) return _getNetworkType.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _getNetworkType.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _getNetworkType.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _getNetworkType.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipayGetNetworkType.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusGetNetworkType.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5GetNetworkType.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getNetworkType'], rest, false));
};
export var getOpenUserInfo = function getOpenUserInfo() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getOpenUserInfo.apply(void 0, rest);
  if (appEnv.isMpLazada) return _getOpenUserInfo.apply(void 0, rest);
  if (appEnv.isMpTaobao) return mpTaobaoGetOpenUserInfo.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _getOpenUserInfo.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusGetOpenUserInfo.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getOpenUserInfo'], rest, false));
};
export var getPaymentCode = function getPaymentCode() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getPaymentCode.apply(void 0, rest);
  if (appEnv.isMpLazada) return _getPaymentCode.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _getPaymentCode.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _getPaymentCode.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getPaymentCode'], rest, false));
};
export var getPhoneNumber = function getPhoneNumber() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getPhoneNumber.apply(void 0, rest);
  if (appEnv.isMpLazada) return _getPhoneNumber.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _getPhoneNumber.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _getPhoneNumber.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipayGetPhoneNumber.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusGetPhoneNumber.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getPhoneNumber'], rest, false));
};
export var getSavedFileInfo = function getSavedFileInfo() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getSavedFileInfo.apply(void 0, rest);
  if (appEnv.isMpLazada) return _getSavedFileInfo.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _getSavedFileInfo.apply(void 0, rest);
  if (appEnv.isWebAlipay) return _getSavedFileInfo.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _getSavedFileInfo.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getSavedFileInfo'], rest, false));
};
export var getSavedFileList = function getSavedFileList() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getSavedFileList.apply(void 0, rest);
  if (appEnv.isMpLazada) return _getSavedFileList.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _getSavedFileList.apply(void 0, rest);
  if (appEnv.isWebAlipay) return _getSavedFileList.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _getSavedFileList.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getSavedFileList'], rest, false));
};
export var getScreenBrightness = function getScreenBrightness() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getScreenBrightness.apply(void 0, rest);
  if (appEnv.isMpLazada) return _getScreenBrightness.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _getScreenBrightness.apply(void 0, rest);
  if (appEnv.isWebAlipay) return _getScreenBrightness.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _getScreenBrightness.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getScreenBrightness'], rest, false));
};
export var getServerTime = function getServerTime() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getServerTime.apply(void 0, rest);
  if (appEnv.isMpLazada) return _getServerTime.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _getServerTime.apply(void 0, rest);
  if (appEnv.isWebAlipay) return _getServerTime.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _getServerTime.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5GetServerTime.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getServerTime'], rest, false));
};
export var getSetting = function getSetting() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getSetting.apply(void 0, rest);
  if (appEnv.isMpLazada) return _getSetting.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _getSetting.apply(void 0, rest);
  if (appEnv.isWebAlipay) return _getSetting.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _getSetting.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getSetting'], rest, false));
};
export var getSiteInfo = function getSiteInfo() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getSiteInfo.apply(void 0, rest);
  if (appEnv.isMpLazada) return _getSiteInfo.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _getSiteInfo.apply(void 0, rest);
  if (appEnv.isWebAlipay) return _getSiteInfo.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _getSiteInfo.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5GetSiteInfo.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getSiteInfo'], rest, false));
};
export var getStorage = function getStorage() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getStorage.apply(void 0, rest);
  if (appEnv.isMpLazada) return _getStorage.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _getStorage.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _getStorage.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _getStorage.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipayGetStorage.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusGetStorage.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5GetStorage.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getStorage'], rest, false));
};
export var getStorageSync = function getStorageSync() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getStorageSync.apply(void 0, rest);
  if (appEnv.isMpLazada) return _getStorageSync.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _getStorageSync.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5GetStorageSync.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getStorageSync'], rest, false));
};
export var getSystemInfo = function getSystemInfo() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getSystemInfo.apply(void 0, rest);
  if (appEnv.isMpLazada) return _getSystemInfo.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _getSystemInfo.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _getSystemInfo.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _getSystemInfo.apply(void 0, rest);
  if (appEnv.isWebAlipay) return _getSystemInfo.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _getSystemInfo.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5GetSystemInfo.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getSystemInfo'], rest, false));
};
export var getSystemInfoSync = function getSystemInfoSync() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getSystemInfoSync.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _getSystemInfoSync.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5GetSystemInfoSync.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getSystemInfoSync'], rest, false));
};
export var hideBackHome = function hideBackHome() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _hideBackHome.apply(void 0, rest);
  if (appEnv.isMpLazada) return _hideBackHome.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _hideBackHome.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['hideBackHome'], rest, false));
};
export var hideKeyboard = function hideKeyboard() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _hideKeyboard.apply(void 0, rest);
  if (appEnv.isMpLazada) return _hideKeyboard.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _hideKeyboard.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _hideKeyboard.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _hideKeyboard.apply(void 0, rest);
  if (appEnv.isWebAlipay) return _hideKeyboard.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _hideKeyboard.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['hideKeyboard'], rest, false));
};
export var hideLoading = function hideLoading() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _hideLoading.apply(void 0, rest);
  if (appEnv.isMpLazada) return _hideLoading.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _hideLoading.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _hideLoading.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _hideLoading.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipayHideLoading.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusHideLoading.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5HideLoading.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['hideLoading'], rest, false));
};
export var hideNavigationBarLoading = function hideNavigationBarLoading() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _hideNavigationBarLoading.apply(void 0, rest);
  if (appEnv.isMpLazada) return _hideNavigationBarLoading.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _hideNavigationBarLoading.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _hideNavigationBarLoading.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipayHideNavigationBarLoading.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusHideNavigationBarLoading.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['hideNavigationBarLoading'], rest, false));
};
export var hideTabBar = function hideTabBar() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _hideTabBar.apply(void 0, rest);
  if (appEnv.isMpLazada) return _hideTabBar.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _hideTabBar.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _hideTabBar.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['hideTabBar'], rest, false));
};
export var hideToast = function hideToast() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _hideToast.apply(void 0, rest);
  if (appEnv.isMpLazada) return _hideToast.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _hideToast.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _hideToast.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _hideToast.apply(void 0, rest);
  if (appEnv.isWebAlipay) return _hideToast.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _hideToast.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5HideToast.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['hideToast'], rest, false));
};
export var inquireQuote = function inquireQuote() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _inquireQuote.apply(void 0, rest);
  if (appEnv.isMpLazada) return _inquireQuote.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _inquireQuote.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _inquireQuote.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['inquireQuote'], rest, false));
};
export var isInstalledApp = function isInstalledApp() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _isInstalledApp.apply(void 0, rest);
  if (appEnv.isMpLazada) return _isInstalledApp.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _isInstalledApp.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _isInstalledApp.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['isInstalledApp'], rest, false));
};
export var makePhoneCall = function makePhoneCall() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _makePhoneCall.apply(void 0, rest);
  if (appEnv.isMpLazada) return _makePhoneCall.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _makePhoneCall.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _makePhoneCall.apply(void 0, rest);
  if (appEnv.isWebAlipay) return _makePhoneCall.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _makePhoneCall.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5MakePhoneCall.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['makePhoneCall'], rest, false));
};
export var multiLevelSelect = function multiLevelSelect() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _multiLevelSelect.apply(void 0, rest);
  if (appEnv.isMpLazada) return _multiLevelSelect.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _multiLevelSelect.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _multiLevelSelect.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipayMultiLevelSelect.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusMultiLevelSelect.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['multiLevelSelect'], rest, false));
};
export var navigateBack = function navigateBack() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _navigateBack.apply(void 0, rest);
  if (appEnv.isMpLazada) return _navigateBack.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _navigateBack.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipayNavigateBack.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusNavigateBack.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5NavigateBack.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['navigateBack'], rest, false));
};
export var navigateBackMiniProgram = function navigateBackMiniProgram() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _navigateBackMiniProgram.apply(void 0, rest);
  if (appEnv.isMpLazada) return _navigateBackMiniProgram.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _navigateBackMiniProgram.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _navigateBackMiniProgram.apply(void 0, rest);
  if (appEnv.isWebAlipay) return _navigateBackMiniProgram.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _navigateBackMiniProgram.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['navigateBackMiniProgram'], rest, false));
};
export var navigateTo = function navigateTo() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipay) return _navigateTo.apply(void 0, rest);
  if (appEnv.isMpAlipayPlus) return _navigateTo.apply(void 0, rest);
  if (appEnv.isMpLazada) return _navigateTo.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _navigateTo.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _navigateTo.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipayNavigateTo.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusNavigateTo.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5NavigateTo.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['navigateTo'], rest, false));
};
export var navigateToBizScene = function navigateToBizScene() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _navigateToBizScene.apply(void 0, rest);
  if (appEnv.isMpLazada) return _navigateToBizScene.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _navigateToBizScene.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _navigateToBizScene.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5NavigateToBizScene.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['navigateToBizScene'], rest, false));
};
export var navigateToMiniProgram = function navigateToMiniProgram() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _navigateToMiniProgram.apply(void 0, rest);
  if (appEnv.isMpLazada) return _navigateToMiniProgram.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _navigateToMiniProgram.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _navigateToMiniProgram.apply(void 0, rest);
  if (appEnv.isWebAlipay) return _navigateToMiniProgram.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _navigateToMiniProgram.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5NavigateToMiniProgram.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['navigateToMiniProgram'], rest, false));
};
export var notifyBLECharacteristicValueChange = function notifyBLECharacteristicValueChange() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _notifyBLECharacteristicValueChange.apply(void 0, rest);
  if (appEnv.isMpLazada) return _notifyBLECharacteristicValueChange.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _notifyBLECharacteristicValueChange.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['notifyBLECharacteristicValueChange'], rest, false));
};
export var offAccelerometerChange = function offAccelerometerChange() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _offAccelerometerChange.apply(void 0, rest);
  if (appEnv.isMpLazada) return _offAccelerometerChange.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['offAccelerometerChange'], rest, false));
};
export var offBLECharacteristicValueChange = function offBLECharacteristicValueChange() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _offBLECharacteristicValueChange.apply(void 0, rest);
  if (appEnv.isMpLazada) return _offBLECharacteristicValueChange.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _offBLECharacteristicValueChange.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['offBLECharacteristicValueChange'], rest, false));
};
export var offBLEConnectionStateChanged = function offBLEConnectionStateChanged() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _offBLEConnectionStateChanged.apply(void 0, rest);
  if (appEnv.isMpLazada) return _offBLEConnectionStateChanged.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _offBLEConnectionStateChanged.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['offBLEConnectionStateChanged'], rest, false));
};
export var offBluetoothAdapterStateChange = function offBluetoothAdapterStateChange() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _offBluetoothAdapterStateChange.apply(void 0, rest);
  if (appEnv.isMpLazada) return _offBluetoothAdapterStateChange.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _offBluetoothAdapterStateChange.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['offBluetoothAdapterStateChange'], rest, false));
};
export var offBluetoothDeviceFound = function offBluetoothDeviceFound() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _offBluetoothDeviceFound.apply(void 0, rest);
  if (appEnv.isMpLazada) return _offBluetoothDeviceFound.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _offBluetoothDeviceFound.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['offBluetoothDeviceFound'], rest, false));
};
export var offCompassChange = function offCompassChange() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _offCompassChange.apply(void 0, rest);
  if (appEnv.isMpLazada) return _offCompassChange.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['offCompassChange'], rest, false));
};
export var offMemoryWarning = function offMemoryWarning() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _offMemoryWarning.apply(void 0, rest);
  if (appEnv.isMpLazada) return _offMemoryWarning.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _offMemoryWarning.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['offMemoryWarning'], rest, false));
};
export var offSocketClose = function offSocketClose() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _offSocketClose.apply(void 0, rest);
  if (appEnv.isMpLazada) return _offSocketClose.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _offSocketClose.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['offSocketClose'], rest, false));
};
export var offSocketError = function offSocketError() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _offSocketError.apply(void 0, rest);
  if (appEnv.isMpLazada) return _offSocketError.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _offSocketError.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['offSocketError'], rest, false));
};
export var offSocketMessage = function offSocketMessage() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _offSocketMessage.apply(void 0, rest);
  if (appEnv.isMpLazada) return _offSocketMessage.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _offSocketMessage.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['offSocketMessage'], rest, false));
};
export var offSocketOpen = function offSocketOpen() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _offSocketOpen.apply(void 0, rest);
  if (appEnv.isMpLazada) return _offSocketOpen.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _offSocketOpen.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['offSocketOpen'], rest, false));
};
export var offUserCaptureScreen = function offUserCaptureScreen() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _offUserCaptureScreen.apply(void 0, rest);
  if (appEnv.isMpLazada) return _offUserCaptureScreen.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _offUserCaptureScreen.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['offUserCaptureScreen'], rest, false));
};
export var onAccelerometerChange = function onAccelerometerChange() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _onAccelerometerChange.apply(void 0, rest);
  if (appEnv.isMpLazada) return _onAccelerometerChange.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['onAccelerometerChange'], rest, false));
};
export var onBLECharacteristicValueChange = function onBLECharacteristicValueChange() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _onBLECharacteristicValueChange.apply(void 0, rest);
  if (appEnv.isMpLazada) return _onBLECharacteristicValueChange.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _onBLECharacteristicValueChange.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['onBLECharacteristicValueChange'], rest, false));
};
export var onBLEConnectionStateChanged = function onBLEConnectionStateChanged() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _onBLEConnectionStateChanged.apply(void 0, rest);
  if (appEnv.isMpLazada) return _onBLEConnectionStateChanged.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _onBLEConnectionStateChanged.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['onBLEConnectionStateChanged'], rest, false));
};
export var onBluetoothAdapterStateChange = function onBluetoothAdapterStateChange() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _onBluetoothAdapterStateChange.apply(void 0, rest);
  if (appEnv.isMpLazada) return _onBluetoothAdapterStateChange.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _onBluetoothAdapterStateChange.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['onBluetoothAdapterStateChange'], rest, false));
};
export var onBluetoothDeviceFound = function onBluetoothDeviceFound() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _onBluetoothDeviceFound.apply(void 0, rest);
  if (appEnv.isMpLazada) return _onBluetoothDeviceFound.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _onBluetoothDeviceFound.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['onBluetoothDeviceFound'], rest, false));
};
export var onCompassChange = function onCompassChange() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _onCompassChange.apply(void 0, rest);
  if (appEnv.isMpLazada) return _onCompassChange.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['onCompassChange'], rest, false));
};
export var onMemoryWarning = function onMemoryWarning() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _onMemoryWarning.apply(void 0, rest);
  if (appEnv.isMpLazada) return _onMemoryWarning.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _onMemoryWarning.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['onMemoryWarning'], rest, false));
};
export var onSocketClose = function onSocketClose() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _onSocketClose.apply(void 0, rest);
  if (appEnv.isMpLazada) return _onSocketClose.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _onSocketClose.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['onSocketClose'], rest, false));
};
export var onSocketError = function onSocketError() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _onSocketError.apply(void 0, rest);
  if (appEnv.isMpLazada) return _onSocketError.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _onSocketError.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['onSocketError'], rest, false));
};
export var onSocketMessage = function onSocketMessage() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _onSocketMessage.apply(void 0, rest);
  if (appEnv.isMpLazada) return _onSocketMessage.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _onSocketMessage.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['onSocketMessage'], rest, false));
};
export var onSocketOpen = function onSocketOpen() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _onSocketOpen.apply(void 0, rest);
  if (appEnv.isMpLazada) return _onSocketOpen.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _onSocketOpen.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['onSocketOpen'], rest, false));
};
export var onUserCaptureScreen = function onUserCaptureScreen() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _onUserCaptureScreen.apply(void 0, rest);
  if (appEnv.isMpLazada) return _onUserCaptureScreen.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _onUserCaptureScreen.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['onUserCaptureScreen'], rest, false));
};
export var openBluetoothAdapter = function openBluetoothAdapter() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _openBluetoothAdapter.apply(void 0, rest);
  if (appEnv.isMpLazada) return _openBluetoothAdapter.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _openBluetoothAdapter.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['openBluetoothAdapter'], rest, false));
};
export var openDocument = function openDocument() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _openDocument.apply(void 0, rest);
  if (appEnv.isMpLazada) return _openDocument.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _openDocument.apply(void 0, rest);
  if (appEnv.isWebAlipay) return _openDocument.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _openDocument.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['openDocument'], rest, false));
};
export var openSchemeWithBacking = function openSchemeWithBacking() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _openSchemeWithBacking.apply(void 0, rest);
  if (appEnv.isMpLazada) return _openSchemeWithBacking.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _openSchemeWithBacking.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _openSchemeWithBacking.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['openSchemeWithBacking'], rest, false));
};
export var openSetting = function openSetting() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _openSetting.apply(void 0, rest);
  if (appEnv.isMpLazada) return _openSetting.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _openSetting.apply(void 0, rest);
  if (appEnv.isWebAlipay) return _openSetting.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _openSetting.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['openSetting'], rest, false));
};
export var pageScrollTo = function pageScrollTo() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _pageScrollTo.apply(void 0, rest);
  if (appEnv.isMpLazada) return _pageScrollTo.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _pageScrollTo.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5PageScrollTo.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['pageScrollTo'], rest, false));
};
export var paySignCenter = function paySignCenter() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _paySignCenter.apply(void 0, rest);
  if (appEnv.isMpLazada) return _paySignCenter.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _paySignCenter.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusPaySignCenter.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['paySignCenter'], rest, false));
};
export var previewImage = function previewImage() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _previewImage.apply(void 0, rest);
  if (appEnv.isMpLazada) return _previewImage.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _previewImage.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _previewImage.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipayPreviewImage.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusPreviewImage.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['previewImage'], rest, false));
};
export var prompt = function prompt() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _prompt.apply(void 0, rest);
  if (appEnv.isMpLazada) return _prompt.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _prompt.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _prompt.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _prompt.apply(void 0, rest);
  if (appEnv.isWebAlipay) return _prompt.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _prompt.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['prompt'], rest, false));
};
export var readBLECharacteristicValue = function readBLECharacteristicValue() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _readBLECharacteristicValue.apply(void 0, rest);
  if (appEnv.isMpLazada) return _readBLECharacteristicValue.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _readBLECharacteristicValue.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['readBLECharacteristicValue'], rest, false));
};
export var redirectTo = function redirectTo() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _redirectTo.apply(void 0, rest);
  if (appEnv.isMpLazada) return _redirectTo.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _redirectTo.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipayRedirectTo.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusRedirectTo.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5RedirectTo.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['redirectTo'], rest, false));
};
export var regionFetchAllApps = function regionFetchAllApps() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _regionFetchAllApps.apply(void 0, rest);
  if (appEnv.isMpLazada) return _regionFetchAllApps.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _regionFetchAllApps.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _regionFetchAllApps.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['regionFetchAllApps'], rest, false));
};
export var regionSearchAppsByKeywords = function regionSearchAppsByKeywords() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _regionSearchAppsByKeywords.apply(void 0, rest);
  if (appEnv.isMpLazada) return _regionSearchAppsByKeywords.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _regionSearchAppsByKeywords.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _regionSearchAppsByKeywords.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['regionSearchAppsByKeywords'], rest, false));
};
export var reLaunch = function reLaunch() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _reLaunch.apply(void 0, rest);
  if (appEnv.isMpLazada) return _reLaunch.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _reLaunch.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['reLaunch'], rest, false));
};
export var removeSavedFile = function removeSavedFile() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _removeSavedFile.apply(void 0, rest);
  if (appEnv.isMpLazada) return _removeSavedFile.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _removeSavedFile.apply(void 0, rest);
  if (appEnv.isWebAlipay) return _removeSavedFile.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _removeSavedFile.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['removeSavedFile'], rest, false));
};
export var removeStorage = function removeStorage() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _removeStorage.apply(void 0, rest);
  if (appEnv.isMpLazada) return _removeStorage.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _removeStorage.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _removeStorage.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _removeStorage.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipayRemoveStorage.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusRemoveStorage.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5RemoveStorage.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['removeStorage'], rest, false));
};
export var removeStorageSync = function removeStorageSync() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _removeStorageSync.apply(void 0, rest);
  if (appEnv.isMpLazada) return _removeStorageSync.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _removeStorageSync.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5RemoveStorageSync.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['removeStorageSync'], rest, false));
};
export var request = function request() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _request.apply(void 0, rest);
  if (appEnv.isMpLazada) return _request.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _request.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _request.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _request.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipayRequest.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusRequest.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5Request.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['request'], rest, false));
};
export var rpc = function rpc() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipay) return _rpc.apply(void 0, rest);
  if (appEnv.isMpAlipayPlus) return _rpc.apply(void 0, rest);
  if (appEnv.isMpLazada) return _rpc.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _rpc.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _rpc.apply(void 0, rest);
  if (appEnv.isWebAlipay) return _rpc.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _rpc.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5Rpc.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['rpc'], rest, false));
};
export var saveFile = function saveFile() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _saveFile.apply(void 0, rest);
  if (appEnv.isMpLazada) return _saveFile.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _saveFile.apply(void 0, rest);
  if (appEnv.isWebAlipay) return _saveFile.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _saveFile.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['saveFile'], rest, false));
};
export var saveImage = function saveImage() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _saveImage.apply(void 0, rest);
  if (appEnv.isMpLazada) return _saveImage.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _saveImage.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _saveImage.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipaySaveImage.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusSaveImage.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['saveImage'], rest, false));
};
export var scan = function scan() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _scan.apply(void 0, rest);
  if (appEnv.isMpLazada) return _scan.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _scan.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _scan.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _scan.apply(void 0, rest);
  if (appEnv.isWebAlipay) return _scan.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _scan.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['scan'], rest, false));
};
export var sendSocketMessage = function sendSocketMessage() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _sendSocketMessage.apply(void 0, rest);
  if (appEnv.isMpLazada) return _sendSocketMessage.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _sendSocketMessage.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['sendSocketMessage'], rest, false));
};
export var setBackgroundColor = function setBackgroundColor() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _setBackgroundColor.apply(void 0, rest);
  if (appEnv.isMpLazada) return _setBackgroundColor.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _setBackgroundColor.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['setBackgroundColor'], rest, false));
};
export var setCanPullDown = function setCanPullDown() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _setCanPullDown.apply(void 0, rest);
  if (appEnv.isMpLazada) return _setCanPullDown.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _setCanPullDown.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['setCanPullDown'], rest, false));
};
export var setClipboard = function setClipboard() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _setClipboard.apply(void 0, rest);
  if (appEnv.isMpLazada) return _setClipboard.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _setClipboard.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _setClipboard.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _setClipboard.apply(void 0, rest);
  if (appEnv.isWebAlipay) return _setClipboard.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _setClipboard.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5SetClipboard.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['setClipboard'], rest, false));
};
export var setKeepScreenOn = function setKeepScreenOn() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _setKeepScreenOn.apply(void 0, rest);
  if (appEnv.isMpLazada) return _setKeepScreenOn.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _setKeepScreenOn.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipaySetKeepScreenOn.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusSetKeepScreenOn.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['setKeepScreenOn'], rest, false));
};
export var setNavigationBar = function setNavigationBar() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _setNavigationBar.apply(void 0, rest);
  if (appEnv.isMpLazada) return _setNavigationBar.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _setNavigationBar.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _setNavigationBar.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _setNavigationBar.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipaySetNavigationBar.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusSetNavigationBar.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5SetNavigationBar.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['setNavigationBar'], rest, false));
};
export var setOptionMenu = function setOptionMenu() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _setOptionMenu.apply(void 0, rest);
  if (appEnv.isMpLazada) return _setOptionMenu.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _setOptionMenu.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _setOptionMenu.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipaySetOptionMenu.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusSetOptionMenu.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['setOptionMenu'], rest, false));
};
export var setScreenBrightness = function setScreenBrightness() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _setScreenBrightness.apply(void 0, rest);
  if (appEnv.isMpLazada) return _setScreenBrightness.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _setScreenBrightness.apply(void 0, rest);
  if (appEnv.isWebAlipay) return _setScreenBrightness.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _setScreenBrightness.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['setScreenBrightness'], rest, false));
};
export var setStorage = function setStorage() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _setStorage.apply(void 0, rest);
  if (appEnv.isMpLazada) return _setStorage.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _setStorage.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _setStorage.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _setStorage.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipaySetStorage.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusSetStorage.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5SetStorage.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['setStorage'], rest, false));
};
export var setStorageSync = function setStorageSync() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _setStorageSync.apply(void 0, rest);
  if (appEnv.isMpLazada) return _setStorageSync.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _setStorageSync.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5SetStorageSync.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['setStorageSync'], rest, false));
};
export var setTabBarStyle = function setTabBarStyle() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _setTabBarStyle.apply(void 0, rest);
  if (appEnv.isMpLazada) return _setTabBarStyle.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _setTabBarStyle.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _setTabBarStyle.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['setTabBarStyle'], rest, false));
};
export var showActionSheet = function showActionSheet() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _showActionSheet.apply(void 0, rest);
  if (appEnv.isMpLazada) return _showActionSheet.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _showActionSheet.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _showActionSheet.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipayShowActionSheet.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusShowActionSheet.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['showActionSheet'], rest, false));
};
export var showAuthGuide = function showAuthGuide() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _showAuthGuide.apply(void 0, rest);
  if (appEnv.isMpLazada) return _showAuthGuide.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _showAuthGuide.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _showAuthGuide.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _showAuthGuide.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipayShowAuthGuide.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusShowAuthGuide.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['showAuthGuide'], rest, false));
};
export var showLoading = function showLoading() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _showLoading.apply(void 0, rest);
  if (appEnv.isMpLazada) return _showLoading.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _showLoading.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _showLoading.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _showLoading.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipayShowLoading.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusShowLoading.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5ShowLoading.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['showLoading'], rest, false));
};
export var showNavigationBarLoading = function showNavigationBarLoading() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _showNavigationBarLoading.apply(void 0, rest);
  if (appEnv.isMpLazada) return _showNavigationBarLoading.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _showNavigationBarLoading.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _showNavigationBarLoading.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipayShowNavigationBarLoading.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusShowNavigationBarLoading.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['showNavigationBarLoading'], rest, false));
};
export var showToast = function showToast() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _showToast.apply(void 0, rest);
  if (appEnv.isMpLazada) return _showToast.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _showToast.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _showToast.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _showToast.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipayShowToast.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusShowToast.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5ShowToast.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['showToast'], rest, false));
};
export var signContract = function signContract() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _signContract.apply(void 0, rest);
  if (appEnv.isMpLazada) return _signContract.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _signContract.apply(void 0, rest);
  if (appEnv.isWebAlipay) return _signContract.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _signContract.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['signContract'], rest, false));
};
export var startApp = function startApp() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _startApp.apply(void 0, rest);
  if (appEnv.isMpLazada) return _startApp.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _startApp.apply(void 0, rest);
  if (appEnv.isWebAlipay) return _startApp.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _startApp.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['startApp'], rest, false));
};
export var startBizService = function startBizService() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _startBizService.apply(void 0, rest);
  if (appEnv.isMpLazada) return _startBizService.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _startBizService.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _startBizService.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['startBizService'], rest, false));
};
export var startBluetoothDevicesDiscovery = function startBluetoothDevicesDiscovery() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _startBluetoothDevicesDiscovery.apply(void 0, rest);
  if (appEnv.isMpLazada) return _startBluetoothDevicesDiscovery.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _startBluetoothDevicesDiscovery.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['startBluetoothDevicesDiscovery'], rest, false));
};
export var startPullDownRefresh = function startPullDownRefresh() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _startPullDownRefresh.apply(void 0, rest);
  if (appEnv.isMpLazada) return _startPullDownRefresh.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _startPullDownRefresh.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['startPullDownRefresh'], rest, false));
};
export var stopBluetoothDevicesDiscovery = function stopBluetoothDevicesDiscovery() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _stopBluetoothDevicesDiscovery.apply(void 0, rest);
  if (appEnv.isMpLazada) return _stopBluetoothDevicesDiscovery.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _stopBluetoothDevicesDiscovery.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['stopBluetoothDevicesDiscovery'], rest, false));
};
export var stopPullDownRefresh = function stopPullDownRefresh() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _stopPullDownRefresh.apply(void 0, rest);
  if (appEnv.isMpLazada) return _stopPullDownRefresh.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _stopPullDownRefresh.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['stopPullDownRefresh'], rest, false));
};
export var switchTab = function switchTab() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _switchTab.apply(void 0, rest);
  if (appEnv.isMpLazada) return _switchTab.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _switchTab.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['switchTab'], rest, false));
};
export var thirdPartyAuthForAc = function thirdPartyAuthForAc() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _thirdPartyAuthForAc.apply(void 0, rest);
  if (appEnv.isMpLazada) return _thirdPartyAuthForAc.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _thirdPartyAuthForAc.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _thirdPartyAuthForAc.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['thirdPartyAuthForAc'], rest, false));
};
export var tradePay = function tradePay() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipay) return mpAlipayTradePay.apply(void 0, rest);
  if (appEnv.isMpAlipayPlus) return _tradePay.apply(void 0, rest);
  if (appEnv.isMpLazada) return _tradePay.apply(void 0, rest);
  if (appEnv.isMpTaobao) return _tradePay.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return mpWebAlipayTradePay.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _tradePay.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipayTradePay.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _tradePay.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['tradePay'], rest, false));
};
export var uploadApdidToken = function uploadApdidToken() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _uploadApdidToken.apply(void 0, rest);
  if (appEnv.isMpLazada) return _uploadApdidToken.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _uploadApdidToken.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _uploadApdidToken.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['uploadApdidToken'], rest, false));
};
export var uploadFile = function uploadFile() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _uploadFile.apply(void 0, rest);
  if (appEnv.isMpLazada) return _uploadFile.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _uploadFile.apply(void 0, rest);
  if (appEnv.isWebAlipay) return webAlipayUploadFile.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return webAlipayPlusUploadFile.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['uploadFile'], rest, false));
};
export var vibrate = function vibrate() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _vibrate.apply(void 0, rest);
  if (appEnv.isMpLazada) return _vibrate.apply(void 0, rest);
  if (appEnv.isMpWebAlipay) return _vibrate.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _vibrate.apply(void 0, rest);
  if (appEnv.isWebAlipay) return _vibrate.apply(void 0, rest);
  if (appEnv.isWebAlipayPlus) return _vibrate.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['vibrate'], rest, false));
};
export var watchShake = function watchShake() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _watchShake.apply(void 0, rest);
  if (appEnv.isMpLazada) return _watchShake.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['watchShake'], rest, false));
};
export var writeBLECharacteristicValue = function writeBLECharacteristicValue() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _writeBLECharacteristicValue.apply(void 0, rest);
  if (appEnv.isMpLazada) return _writeBLECharacteristicValue.apply(void 0, rest);
  if (appEnv.isMpWebAlipayPlus) return _writeBLECharacteristicValue.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['writeBLECharacteristicValue'], rest, false));
};
export var getLaunchOptionsSync = function getLaunchOptionsSync() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isWebH5) return webH5GetLaunchOptionsSync.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getLaunchOptionsSync'], rest, false));
};
export var createSelectorQuery = function createSelectorQuery() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _createSelectorQuery.apply(void 0, rest);
  if (appEnv.isWebH5) return webH5CreateSelectorQuery.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['createSelectorQuery'], rest, false));
};
export var canIUse = function canIUse() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return mpAlipayPlusCanIUse.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['canIUse'], rest, false));
};
export var getStorageInfo = function getStorageInfo() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getStorageInfo.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getStorageInfo'], rest, false));
};
export var getStorageInfoSync = function getStorageInfoSync() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _getStorageInfoSync.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['getStorageInfoSync'], rest, false));
};
export var showSharePanel = function showSharePanel() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _showSharePanel.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['showSharePanel'], rest, false));
};
export var postMessage = function postMessage() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _postMessage.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['postMessage'], rest, false));
};
export var onMessage = function onMessage() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isMpAlipayPlus) return _onMessage.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['onMessage'], rest, false));
};
export var hideOptionButton = function hideOptionButton() {
  var rest = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    rest[_i] = arguments[_i];
  }
  if (appEnv.isWebAlipay) return webAlipayHideOptionButton.apply(void 0, rest);
  return notFound.apply(void 0, __spreadArray(['hideOptionButton'], rest, false));
};